
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/amanaki-boutique-saigon/discover",
      function () {
        return require("private-next-pages/[locale]/amanaki-boutique-saigon/discover/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/amanaki-boutique-saigon/discover"])
      });
    }
  